import { Guid } from "guid-typescript";

class MessageLogAttachment {
    id: Guid;
    title: string;

    constructor(data: Partial<MessageLogAttachment>) {
        Object.assign(this, data);
    }
}

export default MessageLogAttachment;